import React from 'react';
import { Modal, Select } from 'antd';

const VKNSelector = ({ currentUserMerchs, selectedMerch, open, onOk, onCancel, onChange }) => {
  return (
    <Modal
      title="Firma Seç"
      visible={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Kaydet"
      cancelText="Vazgeç"
      width="325px"
    >
      <div>
        <Select
          defaultValue={selectedMerch?.contactName || undefined}
          style={{ width: '100%' }}
          onChange={onChange}
          placeholder="Firma Seç"
        >
          {currentUserMerchs?.map((m) => (
            <Select.Option key={m.identifier} value={JSON.stringify(m)}>
              {m?.contactName}-{m.number}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
};

export default VKNSelector;
